module.exports = __webpack_public_path__ + "static/media/22_A.656dcc00.png";